var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVidaEMinisterioCristao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.833 125.931",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.215.001h-.014a5.813 5.813 0 0 0-4.133 1.712 5.873 5.873 0 0 0-1.736 4.186v88.447a5.918 5.918 0 0 0 5.906 5.9c13.729.033 36.732 2.894 52.6 19.5V27.181a5.652 5.652 0 0 0-.811-2.987C64.003 3.22 38.975.033 25.215.001Z",
    "data-name": "Caminho 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.502 94.346V5.899a5.873 5.873 0 0 0-1.736-4.186 5.815 5.815 0 0 0-4.132-1.712h-.014c-13.76.033-38.788 3.22-51.813 24.194a5.652 5.652 0 0 0-.81 2.987v92.562c15.868-16.606 38.871-19.468 52.6-19.5a5.918 5.918 0 0 0 5.905-5.898Z",
    "data-name": "Caminho 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.934 20.398h-4.277v73.948a15.091 15.091 0 0 1-15.041 15.054c-11.645.028-30.847 2.3-44.446 15.176 23.52-5.759 48.314-2.015 62.444 1.2a5.9 5.9 0 0 0 7.218-5.747V26.295a5.9 5.9 0 0 0-5.898-5.897Z",
    "data-name": "Caminho 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.174 94.346V20.398H5.9A5.9 5.9 0 0 0 0 26.295v93.737a5.9 5.9 0 0 0 7.218 5.747c14.13-3.221 38.925-6.964 62.443-1.2-13.6-12.87-32.8-15.147-44.446-15.175a15.09 15.09 0 0 1-15.041-15.058Z",
    "data-name": "Caminho 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidaEMinisterioCristao);
export default __webpack_public_path__ + "static/media/vida-e-ministerio-cristao.c666e46d2afdfca7a3d8ca72f38c8769.svg";
export { ForwardRef as ReactComponent };